// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer[data-v-12f0e679] {\n  height: 682px;\n  background-size: 100% 100%;\n}\n", ""]);
// Exports
module.exports = exports;
